import { Pipe, PipeTransform } from '@angular/core';

export const COLLAB_TITLE_MAX_LENGTH = 80;

@Pipe({
  name: 'collaborationDynamicTitle',
  standalone: true,
})
export class CollaborationDynamicTitlePipe implements PipeTransform {
  public transform(
    title: string | null | undefined,
    participants?: Array<{ id?: string; firstName?: string; email?: string }>,
    excludeIds?: string[],
  ): string {
    if (title && title.length > 0) {
      return title;
    }

    const participantNames =
      participants
        ?.filter((p) => !p.id || !excludeIds?.includes(p.id))
        .map((p) => p.firstName ?? p.email)
        .sort()
        .join(', ') ?? '';

    return participantNames.length > COLLAB_TITLE_MAX_LENGTH
      ? `${participantNames.slice(0, COLLAB_TITLE_MAX_LENGTH)}...`
      : participantNames;
  }
}
